import React from 'react';
import TeamDescription from './TeamDescription';

function CoreTeam() {
    return (
        <div id='team' className='tabcontent'>
            <div id='core-team' className='fh5co-features-outer'>
                <div className='container'>
                    <TeamDescription />
                </div>
            </div>
        </div>
    );
}

export default CoreTeam;
